import i18next from 'i18next';

export const i18n: any = {
    translate: (key: string, interpolation?: any) => {
        return i18next.t(key, interpolation);
    },
};
